import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import cdpService from "../../../apiService/cdp.service";
import Loader from '../../Global/Loader';

const GenderDemographicsChart = ({ filters = {} }) => {
  const [chartData, setChartData] = useState([
    ["Gender", "Total Users", { role: "style" }],
  ]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, [filters]);

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await cdpService.getGenderChart(filters);

      if (response.data.success) {
        const { genderData } = response.data.data;

        const formattedData = [
          ["Gender", "Total Users", { role: "style" }],
          ["Male", genderData.maleCount || 0, "#06b0f0"],
          ["Female", genderData.femaleCount || 0, "#f75b95"],
          ["Not Disclosed", genderData.othersCount || 0, "gray"],
        ];

        setChartData(formattedData);
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      setError("Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  const options = {
    pieHole: 0.6,
    is3D: false,
    sliceVisibilityThreshold: 0, 
    legend: {
      position: "right",
      alignment: "center",
      textStyle: {
        color: "#233238",
        fontSize: 10,
      },
    },
    chartArea: {
      left: 10,
      right: 10,
      bottom: 20,
      top: 20,
      width: "100%",
      height: "100%",
    },
    colors: ["#06b0f0", "#f75b95", "gray"],
  };

  if (loading) return <Loader />;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <Chart
      chartType="PieChart"
      width="100%"
      height="280px"
      data={chartData}
      options={options}
    />
  );
};

export default GenderDemographicsChart;
